export default __webpack_public_path__ + "static/media/chores-mobile.28b52c7d.png";